"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[15776],{

/***/ 15776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pro_tools_Comparison; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/LandingPage/index.ts + 8 modules
var LandingPage = __webpack_require__(55781);
// EXTERNAL MODULE: ./src/features/pro-tools/constants.ts
var constants = __webpack_require__(23443);
;// CONCATENATED MODULE: ./src/features/pro-tools/Comparison/content.ts
var comparisonContents = [
    {
        title: "Auto-Generated Peers",
        description: "Sistem kami secara otomatis akan membantu membandingkan emiten pilihan Anda dengan emiten sejenisnya sehingga tidak perlu lagi repot dan bingung mencari perbandingan emiten yang sesuai.",
        image: "Comparison_Auto_Generate_Blue.jpg"
    },
    {
        title: "Komparasi secara Rinci",
        description: "Dilengkapi dengan puluhan rasio dan financial metrics, laukan komparasi emiten dari berbagai aspek secara rinci dan mudah. Ditambah adanya angka rata-rata untuk masing-masing industri dan sektor emiten terkait sebagai pembanding untuk membantu memilih emiten yang paling sesuai dengan kriteria.",
        image: "Comparison_Rinci_Blue.jpg"
    }, 
];
/* harmony default export */ var content = (comparisonContents);

;// CONCATENATED MODULE: ./src/features/pro-tools/Comparison/index.tsx




function Comparison() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage/* PageHeader */.mr, {
                title: "Comparison",
                description: "Ambil keputusan yang tepat dengan membandingkan data keuangan antar perusahaan dengan mudah"
            }),
            content.map(function(content, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage/* SectionBrowser */.Dr, {
                    title: content.title,
                    image: "".concat(constants/* ASSET_URL */.Z).concat(content.image),
                    description: content.description,
                    reverse: index % 2 === 0
                });
            })
        ]
    });
}
/* harmony default export */ var pro_tools_Comparison = (Comparison);


/***/ })

}]);